import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styles from "./ProcessPanelLiveMode.module.css";
import { AgendaItem } from "src/types";

const ProcessPanelLiveModeBase = observer(() => {
    const { agendaitemStore, assemblyStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const currentItem = agendaitemStore.currentAgendaItem;

    const onClickAgendaItem = useCallback(
        (item: AgendaItem) => async (e: React.MouseEvent) => {
            e.preventDefault();
            assemblyStore.setIsCloseLiveModeTabActive(false);
            assemblyStore.setIsAttendanceLiveModeTabActive(false);
            agendaitemStore.setCurrentAgendaItem(item);
        },
        [agendaitemStore, assemblyStore]
    );

    const onCloseClick = useCallback(() => {
        assemblyStore.setIsCloseLiveModeTabActive(true);
        assemblyStore.setIsAttendanceLiveModeTabActive(false);
        agendaitemStore.setCurrentAgendaItem(undefined);
    }, [assemblyStore, agendaitemStore]);

    const onAttendancelistClick = useCallback(() => {
        assemblyStore.setIsAttendanceLiveModeTabActive(true);
        assemblyStore.setIsCloseLiveModeTabActive(false);
        agendaitemStore.setCurrentAgendaItem(undefined);
    }, [assemblyStore, agendaitemStore]);

    return (
        <div className={styles.ProcessPanel}>
            <ul className={styles.AgendaList}>
                <li
                    className={`${styles.HeaderItem} ${
                        assemblyStore.isAttendanceLiveModeTabActive ? styles.ActiveItem : ""
                    }`}
                    onClick={onAttendancelistClick}
                >
                    {t("screens.assemblies.attendanceList")}
                </li>

                {agendaitemStore.currentAgendaItems.map((parent) => (
                    <React.Fragment key={parent.id}>
                        <li
                            className={`${styles.ParentItem} ${currentItem?.id === parent.id ? styles.ActiveItem : ""}`}
                            onClick={onClickAgendaItem(parent)}
                        >
                            {parent.sort}. {parent.text}
                        </li>

                        {parent.agendaitemchild?.map((child) => (
                            <li
                                key={child.id}
                                className={`${styles.ChildItem} ${
                                    currentItem?.id === child.id ? styles.ActiveItem : ""
                                }`}
                                onClick={onClickAgendaItem(child)}
                            >
                                {parent.sort}.{child.sort} {child.text}
                            </li>
                        ))}
                    </React.Fragment>
                ))}

                <li
                    className={`${styles.FooterItem} ${
                        assemblyStore.isCloseLiveModeTabActive ? styles.ActiveItem : ""
                    }`}
                    onClick={onCloseClick}
                >
                    {t("screens.assemblies.livemode.close")}
                </li>
            </ul>
        </div>
    );
});

export const ProcessPanelLiveMode = Sentry.withProfiler(ProcessPanelLiveModeBase);
